import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import GroupsCard from './GroupsCard';

import './Groups.css';

@inject('translationsStore', 'driversStore', 'filterStore')
@observer
export default class Groups extends Component {
  componentDidMount = () => {
    const { filterStore } = this.props;
    filterStore.addToMonitoring('groupFilter.all');
    filterStore.addToMonitoring('groupFilter.active');
    filterStore.addToMonitoring('groupFilter.notactive');
  };

  selectAll = () => {
    this.props.onSelect({ selected: 'all' });
    this.props.onGroupChange();
  };

  selectActiveDrivers = () => {
    this.props.onSelect({ selected: 'active' });
    this.props.onGroupChange('active');
  };

  selectNotActiveDrivers = () => {
    this.props.onSelect({ selected: 'notactive' });
    this.props.onGroupChange('notactive');
  };

  render() {
    const { translationsStore, driversStore } = this.props;
    return (
      <div className="Groups">
        <GroupsCard
          name="all"
          title={translationsStore.translate('driversManager.groups.aggregatedAllDrivers')}
          description={driversStore.groupsLength('groupFilter', 'all')}
          selected={this.props.selected === 'all'}
          onClick={this.selectAll}
        />
        <GroupsCard
          name="active"
          title={translationsStore.translate('driversManager.groups.aggregatedActiveDrivers')}
          description={driversStore.groupsLength('groupFilter', 'active')}
          selected={this.props.selected === 'active'}
          onClick={this.selectActiveDrivers}
          theme="alternative"
        />
        <GroupsCard
          name="notactive"
          title={translationsStore.translate('driversManager.groups.aggregatedNotActiveDrivers')}
          description={driversStore.groupsLength('groupFilter', 'notactive')}
          selected={this.props.selected === 'notactive'}
          onClick={this.selectNotActiveDrivers}
          theme="alternative"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/Groups/Groups.js